const PREFECTURE_PATTERN =
  /北海道|東京都|京都府|大阪府|(?:青森|岩手|宮城|秋田|山形|福島|茨城|栃木|群馬|埼玉|千葉|神奈川|新潟|富山|石川|福井|山梨|長野|岐阜|静岡|愛知|三重|滋賀|兵庫|奈良|和歌山|鳥取|島根|岡山|広島|山口|徳島|香川|愛媛|高知|福岡|佐賀|長崎|熊本|大分|宮崎|鹿児島|沖縄)県/;

function toHalfWidthAscii(value: string): string {
  return value.normalize("NFKC");
}

function compact(value: string): string {
  return toHalfWidthAscii(value)
    .replace(/[\u3000\s]+/g, "")
    .trim();
}

function stripPostalCode(value: string): string {
  return value.replace(/〒?\s*\d{3}\s*-?\s*\d{4}/g, "");
}

function fromPrefecture(value: string): string {
  const match = value.match(PREFECTURE_PATTERN);
  return match?.index === undefined ? value : value.slice(match.index);
}

function stripAddressMemo(value: string): string {
  return value.split(/[※#]|備考[:：]?|メモ[:：]?|受付[:：]?/)[0] ?? value;
}

function extractStreetAddress(value: string): string {
  const normalized = stripAddressMemo(fromPrefecture(stripPostalCode(toHalfWidthAscii(value))));
  const compacted = normalized.replace(/[\u3000\s]+/g, "");
  const street = compacted.match(
    /^(.+?(?:\d+丁目\d+(?:[-ー－−‐]\d+){0,4}(?:番地?|番)?\d*号?|\d+(?:[-ー－−‐]\d+){1,4}|\d+番地?\d*号?|\d+番\d*号?))/,
  );
  return street?.[1] ?? compacted;
}

export function normalizeAddressCore(raw: string | null | undefined): string {
  if (!raw) return "";
  return extractStreetAddress(raw)
    .replace(/[ー－−‐]/g, "-")
    .replace(/丁目|番地|番|号/g, "")
    .replace(/[()（）[\]「」『』]/g, "")
    .toLowerCase();
}

export function normalizeMasterName(raw: string | null | undefined): string {
  if (!raw) return "";
  return compact(raw)
    .replace(/株式会社|有限会社|\(株\)|\(有\)|（株）|（有）/g, "")
    .replace(/[()（）[\]「」『』]/g, "")
    .toLowerCase();
}

export function normalizePhoneNumber(raw: string | null | undefined): string {
  if (!raw) return "";
  return toHalfWidthAscii(raw).replace(/\D+/g, "");
}

export function buildMasterIdentityKey(input: {
  address: string | null | undefined;
  name: string | null | undefined;
}): string | null {
  const address = normalizeAddressCore(input.address);
  const name = normalizeMasterName(input.name);
  return address && name ? `${address}|${name}` : null;
}
